export { default as IndexLayout } from './IndexLayout';
